module.exports = __webpack_public_path__ + "static/media/flag-is.ec0b31f1.webp";